const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Users selected component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Users the resource defined to get and set User data
 * @argument {Resource} Analyze the resource defined to get and set User data
 */
app.directive('usersSelected', ['Authorization', 'Users', '$q', function (Authorization, Users, $q) {
  return {
    restrict: 'E',
    scope: {
      query: '=',
      userFields: '@'
    },
    template: require('../../templates/directives/users-selected.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.external_department = Authorization.getAuthToken().company && Authorization.getAuthToken().company.external_department;
      self.page = 1;
      self.per_page = 10;
      self.count = 0;
      self.users = [];
      self.pageQuery = {};
      self.is_external = false;
      self.externalQuery = null;
      self.internalQuery = null;
      self.searchingUsersQuery = {};

      self.userRequest = function(isSearch) {
        if (self.is_external && self.internalQuery && self.externalQuery) {
          self.constructQuery(self.internalQuery);
          self.constructQuery(self.externalQuery);
          return $q.all([
            Users.find(self.internalQuery).$promise,
            Users.find(self.externalQuery).$promise
          ]).then(function(results) {
            var users = [];
            if (results[0] && results[0].length) {
              users = users.concat(results[0]);
            }
            if (results[1] && results[1].length) {
              users = users.concat(results[1]);
            }
            return users;
          });
        }
        self.pageQuery = isSearch ? self.searchingUsersQuery : Object.assign({}, $scope.query);
        self.constructQuery(self.pageQuery);
        return Users.find(self.pageQuery).$promise
      };

      self.constructQuery = function(query) {
        query.page = self.page;
        query.per_page = self.per_page;
        query.include_lineage = true;
      };

      self.load = function(isSearch = false) {
        self.previewLoading = true;

        self.userRequest(isSearch)
        .then(function(users) {
          self.endOfLine = users.length < self.per_page;
          self.users = users;
          if (!users.length && self.page > 1) {
            self.page--;
          }
          self.previewLoading = false;
          self.showingUsers = true;
        });
      };

      self.preview = function() {
        if (self.closed) {
          self.closed = false;
          self.showingUsers = true;
          return;
        }
        self.page = 1;
        self.load();
      };

      self.previousPage = function() {
        if (self.page < 2) {
          return;
        }
        self.endOfLine = false;
        self.page--;
        self.load();
      };

      self.nextPage = function() {
        self.page++;
        self.load();
      };

      self.getLocation = function(user) {
        if (user && user.linked_locations && user.linked_locations[0]) {
          return user.linked_locations[0].name;
        }
        return '------';
      };

      self.getDepartment = function(user) {
        if (user && user.linked_departments && user.linked_departments[0]) {
          return user.linked_departments[0].name;
        }
        return '------';
      };

      self.close = function() {
        self.showingUsers = false;
        self.closed = true;
      };

      self.getCount = function(query) {
        query.include_lineage = true;
        return Users.count(query).$promise;
      };

      self.newCount = function(count) {
        self.count = count;
        if (self.showingUsers) {
          self.page = 1;
          self.load();
          return;
        }
      };

      self.attachSearchQuery = function(query, query_arguments) {
        const catMap = {
          departments: 'linked_departments',
          grades: 'linked_grades',
          locations: 'linked_locations',
          org_levels: 'linked_org_levels',
          teams: 'linked_teams',
          groups: 'linked_groups'
        };
        for (const key in query_arguments) {
          if (catMap[key]) {
            const privacyField = catMap[key];
            if (query[privacyField]) {
              const currentPrivacyIds = query[privacyField].split(',').splice(0, 2);
              const allPrivacyIds = currentPrivacyIds.concat(query_arguments[key]);
              const allPrivacyIdsString = allPrivacyIds.join(',');
              query[privacyField] = `$in,${allPrivacyIds.length},${allPrivacyIdsString}`;
            } else {
              const searchedPrivacyIds = query_arguments[key].join(',');
              query[privacyField] = `$in,${query_arguments[key].length},${searchedPrivacyIds}`;
            }
          }
          if (key === 'users') {
            const userIds = query_arguments.users.join(',');
            query._id = `$in,${query_arguments.users.length},${userIds}`;
          }
          if (key === 'text') {
            // plain text search will search name
            query.full_name = `$regex,2,${query_arguments[key]},i`;
          }
        }
      }

      self.searchItems = {
        onQuery: function(query_arguments) {
          // TODO: add to the filter to include already set privacy details
          if (self.is_external && self.internalQuery && self.externalQuery) {
            self.attachSearchQuery(self.internalQuery, query_arguments);
            self.attachSearchQuery(self.externalQuery, query_arguments);
          } else {
            self.searchingUsersQuery = Object.assign({}, $scope.query);
            self.attachSearchQuery(self.searchingUsersQuery, query_arguments);
          }
          self.load(true);
        }
      };
        
      self.initialize = function() {
        if ($scope.userFields) {
          self.fields = $scope.userFields.split(',');
        }
        $scope.$watch('query', function(newVal, oldVal) {
          self.is_external = false;
          self.externalQuery = null;
          self.internalQuery = null;
          if (!$scope.query) {
            return;
          }

          if ($scope.query.linked_departments && self.external_department) {
            var departments = $scope.query.linked_departments.split(',');
            if (departments.indexOf(self.external_department) !== -1) {
              self.is_external = true;
            }
          }
          if ($scope.query.cancel) {
            self.count = 0;
            self.showingUsers = false;
            return;
          }
          if ($scope.query && Object.keys($scope.query).length > 0) {
            self.closed = false;
            self.endOfLine = false;
            self.users = [];
            $scope.query.suspended = '$ne,true';
            if (self.is_external) {
              // one query for external users matching non departments
              // one query for non-external users matching all
              self.externalQuery = Object.assign({}, $scope.query);
              self.externalQuery.role = 'external';
              delete self.externalQuery.linked_departments;

              self.internalQuery = Object.assign({}, $scope.query);
              self.internalQuery.role = '$ne,external';
              $q.all([self.getCount(self.externalQuery), self.getCount(self.internalQuery)])
              .then(function(results) {
                var count = results[0].count + results[1].count;
                count = count > 0 ? count : 0;
                self.newCount(count);
              });
              return;
            }
            $scope.query.role = '$ne,external';
            self.getCount($scope.query)
            .then(function (count) {
              if (count.count > 0) {
                self.showingUsers = true;
              }
              self.newCount(count.count);
            });
          }
        }, true);
      };

      self.initialize();

    }],
    controllerAs: 'selection'
  };
}]);